import { Component, OnChanges, Input, Output, EventEmitter, DoCheck } from '@angular/core';
import * as $ from 'jquery';



@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})
export class AlertComponent implements OnChanges, DoCheck {

	msg : any = {};
	showAlter: boolean = false;
	@Input() msg_type : any;
	@Input() message : any;
	@Output() navigateAction = new EventEmitter();

	constructor() {
	}

	
	success() {
		this.showAlter = true;
		if (this.message.length ===0){
			this.message = 'You have submitted.';
		}
		this.msg = {"key":"success", "text": this.message}
		/*$('#virtueAlertBox').hide();
		setTimeout(()=>{
			$('body').append($('#virtueAlertBox').html());
		}, 500);*/
		this.scheduleRemoval(this.msg_type);
	}
	 
	failure() {
		this.showAlter = true;
		if (this.message.length ===0){
			this.message = 'Please verify all fields before submit.';
		}
		this.msg = {"key":"danger", "text": this.message}
		/*$('#virtueAlertBox').hide();
		setTimeout(()=>{
			$('body').append($('#virtueAlertBox').html());
		}, 500);*/
		this.scheduleRemoval(this.msg_type);
	}
	 
    scheduleRemoval(typeMessage){
		setTimeout(()=>{
			this.msg = {};
			this.showAlter = false;
			this.message = '';
			//$('body').children('div#vab').remove();
			this.navigateAction.emit(typeMessage);
		}, 1000);
	}

	remove(){
		this.msg = {};
		this.showAlter = false;
		this.navigateAction.emit(this.msg_type);
	}

	ngOnChanges() {
		//this.showAlter = true;
        if (this.msg_type === 'success')
        	this.success();
        else if (this.msg_type === 'danger')
        	this.failure();
    }

    ngDoCheck(){
        if (this.msg_type === 'success')
        	this.success();
        else if (this.msg_type === 'danger')
        	this.failure();
    }
}
